import { render } from "./patient_report.vue?vue&type=template&id=62ff0ce2"
import script from "./patient_report.js?vue&type=script&lang=js"
export * from "./patient_report.js?vue&type=script&lang=js"

import "./patient_report.vue?vue&type=style&index=0&id=62ff0ce2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__